export class BoltTeaser {
  constructor(el) {
    if (!el) return;
    this.el = el;
    this.prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    );
    this.init();
  }

  init() {
    this.lottiePlayer = this.el.querySelector('lottie-player');
    if (!this.lottiePlayer) return;

    this.lottiePlayer.setAttribute('loop', 'true');
    this.lottiePlayer.setAttribute('aria-hidden', 'true');

    // Handle reduced motion preference
    this.handleReducedMotion(this.prefersReducedMotion.matches);

    // Listen for changes to reduced motion preference
    this.prefersReducedMotion.addEventListener('change', (event) =>
      this.handleReducedMotion(event.matches),
    );

    this.addHoverListeners();
    this.addFocusListeners();
  }

  handleReducedMotion(prefersReducedMotion) {
    if (prefersReducedMotion) {
      this.lottiePlayer.stop();
    }
  }

  addHoverListeners() {
    this.el.addEventListener('mouseenter', () => {
      if (this.prefersReducedMotion.matches) return;
      this.lottiePlayer.play();
    });

    this.el.addEventListener('mouseleave', () => {
      if (this.prefersReducedMotion.matches) return;
      this.lottiePlayer.pause();
    });
  }

  addFocusListeners() {
    const headlineLink = this.el.querySelector('.c-bolt-headline > a');
    if (!headlineLink) return;

    headlineLink.addEventListener('focus', () => {
      if (this.prefersReducedMotion.matches) return;
      this.lottiePlayer.play();
    });

    headlineLink.addEventListener('blur', () => {
      if (this.prefersReducedMotion.matches) return;
      this.lottiePlayer.pause();
    });
  }
}
